import { CoverageNeedsFields } from '@/components/Chat/CoverageNeedsFields'
import { FieldError } from '@/components/ui/field'
import { checksForCard, FillCard, type FillCheck } from '@/models/fillApplication'
import type { EnabledCoverage } from '@/models/insuranceCoverage'
import { FillSectionCard } from './FillSectionCard'
import { FillTabSection } from './FillTabSection'
import type { CoverageCardForm } from './useCoverageCardForm'

interface CoverageCardProps {
  checks: FillCheck[]
  form: CoverageCardForm
  /** No card around the fields, for a surface that's already one, e.g. a dialog. */
  plain?: boolean
  /** The coverages this business can choose; trucking's when not given. */
  menu?: ReadonlyArray<EnabledCoverage>
}

export function CoverageCard({ checks, form, plain, menu }: CoverageCardProps) {
  return (
    <FillTabSection
      card={FillCard.COVERAGE}
      title="Coverage"
      checks={checksForCard(checks, FillCard.COVERAGE)}
      saving={form.saving}
    >
      {/* Plain, the fields' own labels say what this is, so the title would only repeat them. */}
      <FillSectionCard title={plain ? undefined : 'Start date and coverages'} plain={plain}>
        <CoverageNeedsFields
          form={form.coverage.form}
          idPrefix="fill-cn"
          largeIcons
          compact={plain}
          menu={menu}
          // A dialog is wider than a form field should be.
          className={plain ? 'max-w-md' : undefined}
        />
        <FieldError>{form.coverage.form.formState.errors.root?.server.message}</FieldError>
      </FillSectionCard>
    </FillTabSection>
  )
}
